import React from 'react';
import styled from 'styled-components';
import SVGIcon, { EXCLAMATION } from './SVGIcon';

const FallbackUILayout = styled.div`
  text-align: center;
  margin: 32px;
`;

const ErrorText = styled.p`
  display: block;
  max-width: 600px;
  margin: auto;
`;

const ErrorBoundaryFallbackUI = () => (
  <FallbackUILayout>
    <SVGIcon icon={EXCLAMATION} />
    <ErrorText>
      Oops, it looks like something went wrong. We`re working on fixing this issue as quickly as we
      can. Please refresh the page and try again. If you continue to see this message, please
      contact us at <a href="tel:1-888-760-1940">1 (888) 760 1940</a> for assistance.
    </ErrorText>
  </FallbackUILayout>
);

export default ErrorBoundaryFallbackUI;
